const { SYSTEM_TYPE } = require('./systemConfig')

export const basePath = ''
export const LIVE_MALL_CLUB_ROUTE_PATH = {
  HOME: '/',
  PRODUCT: '/product',
  PRODUCT_DETAIL: '/product/[id]',
  PRODUCT_DETAIL_SPECS: '/product/[id]/specs',
  USER: '/user',
  USER_DETAIL: '/user/[id]',
  SHOPPINGCART: '/shopping-cart',
  LIVE_ROOM: '/live/[roomId]',
  LIVE_ROOM_PRODUCT: '/live/product', // 獨立的直播間商品列表，主要給 app 用
  REDIRECT: 'da3bec811f9b',
  ORDERS: '/orders',
  ME_ACCOUNT: '/me/account',
  ME_ADDRESS: '/me/address',
  // ME_COUPON: '/me/coupon', // 預期之後的功能會使用到，先留著
  MY_LIVE: '/my-live',
  SEARCH: '/search',
  SEARCH_TAG: '/search/tag',
  NOT_FOUND: '/404',
  EXPLORE: '/explore',
  FOLLOW: '/follow',
  PROFILE: '/profile',
  PROFILE_PAGE: '/profile/[[...id]]',
  LANDING_PAGE: '/landing-page/[eventName]',
  APPLY: '/apply',
  APPLY_MERCHANT: '/apply/merchant',
  APPLY_MERCHANT_STEPS: '/apply/merchant/steps',
  APPLY_MERCHANT_INFORMATION: '/apply/merchant/information',
  APPLY_MERCHANT_BANK_ACCOUNT: '/apply/merchant/bank-account',
  APPLY_MERCHANT_UPLOAD_DOCUMENTS: '/apply/merchant/upload-documents',
  APPLY_MERCHANT_AGREEMENT: '/apply/merchant/agreement',
  APPLY_MERCHANT_REVIEW: '/apply/merchant/review',
  APPLY_MERCHANT_REAL_NAME_VERIFICATION: '/apply/merchant/real-name-verification',
  APPLY_MERCHANT_SUCCESS: '/apply/merchant/success',
  PAYMENT_RESULT: '/payment-result',
  APPLY_KOL: '/apply/kol',
  APPLY_KOL_STEPS: '/apply/kol/steps',
  APPLY_KOL_INFORMATION: '/apply/kol/information',
  APPLY_KOL_SOCIAL_MEDIA_LINK: '/apply/kol/social-media-link',
  APPLY_KOL_REAL_NAME_VERIFICATION: '/apply/kol/real-name-verification',
  APPLY_KOL_BANK_ACCOUNT: '/apply/kol/bank-account',
  APPLY_KOL_AGREEMENT: '/apply/kol/agreement',
  APPLY_KOL_REVIEW: '/apply/kol/review',
  APPLY_KOL_SUCCESS: '/apply/kol/success',
  PAYMENT_REDIRECT: '/payment-redirect',
  TERMS: '/terms',
  ACCOUNT_SECURITY_EMAIL: '/me/account/email',
  ACCOUNT_SECURITY_MOBILE: '/me/account/mobile',
  ACCOUNT_SECURITY_PASSWORD: '/me/account/password',
  ACCOUNT_SECURITY_LINKED_ACCOUNTS: '/me/account/linked-accounts',
  ACCOUNT_SECURITY_OFFICIAL_VERIFICATION: '/me/account/official-verification',
  TERMS_LEGAL: '/terms/legal',
  LIVE: '/live',
  ABOUT: '/about',
  ABOUT_TERMS: '/about/terms',
  ABOUT_PRIVACY_POLICY: '/about/privacy-policy',
  API_PAYMENT_REDIRECT: '/v1/payment/redirect/home',
  SHARE: '/share',
  LOGIN: '/login',
  REGISTER: '/register',
  INVITATION: '/landing-page/invitation',
  FORGOT_PASSWORD: '/forgot-password',
  MY_LIVE_RECORDS: '/my-live/records',
}

export const SHOP_ROUTE_PATH = {
  HOME: '/', // 現在 / 給 /live 用，所以導頁時直接導 /live，next config 也有 redirect / -> /live
  LIVE: '/live',
  MALL: '/mall',
  PRODUCT: '/product',
  PRODUCT_DETAIL: '/product/[id]',
  USER: '/user',
  USER_DETAIL: '/user/[id]',
  SHOPPINGCART: '/shopping-cart',
  LIVE_ROOM: '/live/[roomId]',
  STRAWBERRY_LIVE_ROOM: '/strawberry/live/[roomId]', // 草莓網直播間
  STRAWBERRY_LIVE: '/strawberry/live', // 草莓網直播間
  PCHOME_LIVE_ROOM: '/pchome/live/[roomId]', // PCHOME直播間
  PCHOME_LIVE: '/pchome/live', // PCHOME直播間
  BRAND_LIVE_ROOM: '/[brandName]/live/[roomId]', // 品牌直播間 (brandName 是動態的，定義在 @/src/constants/brand.ts)
  LIVE_ROOM_PRODUCT: '/live/product', // 獨立的直播間商品列表，主要給 app 用
  REDIRECT: 'da3bec811f9b',
  ORDER_RESULT: '/order-result',
  ORDERS: '/orders',
  ME: '/me',
  ME_ACCOUNT: '/me/account',
  ME_ACCOUNT_AVATAR: '/me/account/avatar',
  ME_ADDRESS: '/me/address',
  ME_PHONE_CARRIER: '/me/phone-carrier',
  ME_COMPANY_UNIFORM_INVOICE: '/me/company-uniform-invoice',
  ME_COUPON: '/me/coupon',
  MY_LIVE_SHOPLIST: '/my-live/shoplist',
  MY_LIVE_FUTURE: '/my-live/future',
  MY_LIVE_PAST: '/my-live/past',
  SEARCH: '/search',
  SEARCH_MERCHANT: '/search/merchant',
  SEARCH_LIVE: '/search/live',
  SEARCH_TAG: '/search/tag',
  ANALYSIS: '13df2c93a0b7',
  SEARCH_APP: '/search/app',
  EVENT_DETAIL: '/event/[id]',
  EVENT: '/event',
  NOT_FOUND: '/404',
  CALENDAR: '/calendar',
  LANDING_PAGE: '/landing-page/[eventName]',
  LEGAL_DISCLAIMER: '/terms/legal-disclaimer',
  PRIVACY_POLICY: '/terms/privacy-policy',
  USER_TERMS: '/terms/user-terms',
  SAVE_LOCAL_INFORMATION: '/5ojypugpnmdw',
  SHARE: '/share',
}

const ROUTE_PATH_DATA: any = {
  [SYSTEM_TYPE.SHOP]: SHOP_ROUTE_PATH,
  [SYSTEM_TYPE.LIVE_MALL_CLUB]: LIVE_MALL_CLUB_ROUTE_PATH,
}

export const ROUTE_PATH = ROUTE_PATH_DATA[`${process.env.SYSTEM_TYPE}`]

const ROUTE_PATH_FOR_FORBIDDEN_PAGE_DATA: any = {
  [SYSTEM_TYPE.SHOP]: {
    EXPLORE: '/explore',
  },
  [SYSTEM_TYPE.LIVE_MALL_CLUB]: {
    LIVE: '/live',
    MALL: '/mall',
  },
}

export const ROUTE_PATH_FOR_FORBIDDEN_PAGE = ROUTE_PATH_FOR_FORBIDDEN_PAGE_DATA[`${process.env.SYSTEM_TYPE}`]

export const API_PATH_DATA: any = {
  [SYSTEM_TYPE.SHOP]: {
    PAYMENT_REDIRECT: '/v1/payment/redirect',
    LOGISTICS_GET_MAP_REDIRECT: '/v1/logistics/get-map/c2c-store',
  },
  [SYSTEM_TYPE.LIVE_MALL_CLUB]: {
    PAYMENT_REDIRECT: '/v1/payment/redirect',
    LOGISTICS_GET_MAP_REDIRECT: '/v1/logistics/get-map/c2c-store',
  },
}

export const API_PATH = API_PATH_DATA[`${process.env.SYSTEM_TYPE}`]
